var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0333 4.64997H15.7L12.8833 1.8333C12.6583 1.6083 12.2917 1.6083 12.0583 1.8333C11.8333 2.0583 11.8333 2.42497 12.0583 2.6583L14.05 4.64997H5.94999L7.94166 2.6583C8.16666 2.4333 8.16666 2.06663 7.94166 1.8333C7.71666 1.6083 7.34999 1.6083 7.11666 1.8333L4.30832 4.64997H3.97499C3.22499 4.64997 1.66666 4.64997 1.66666 6.7833C1.66666 7.59163 1.83332 8.12497 2.18332 8.47497C2.38332 8.6833 2.62499 8.79163 2.88332 8.84997C3.12499 8.9083 3.38332 8.91663 3.63332 8.91663H16.3667C16.625 8.91663 16.8667 8.89997 17.1 8.84997C17.8 8.6833 18.3333 8.1833 18.3333 6.7833C18.3333 4.64997 16.775 4.64997 16.0333 4.64997Z",
    fill: "#00a14b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 10H4.05832C3.54165 10 3.14999 10.4583 3.23332 10.9667L3.93332 15.25C4.16665 16.6833 4.79165 18.3333 7.56665 18.3333H12.2417C15.05 18.3333 15.55 16.925 15.85 15.35L16.6917 10.9917C16.7917 10.475 16.4 10 15.875 10ZM9.99999 16.25C8.04999 16.25 6.45832 14.6583 6.45832 12.7083C6.45832 12.3667 6.74165 12.0833 7.08332 12.0833C7.42499 12.0833 7.70832 12.3667 7.70832 12.7083C7.70832 13.975 8.73332 15 9.99999 15C11.2667 15 12.2917 13.975 12.2917 12.7083C12.2917 12.3667 12.575 12.0833 12.9167 12.0833C13.2583 12.0833 13.5417 12.3667 13.5417 12.7083C13.5417 14.6583 11.95 16.25 9.99999 16.25Z",
    fill: "#00a14b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketBold);
export default __webpack_public_path__ + "static/media/basket-bold.2a7c3cd054ee7749a32ed352f3546654.svg";
export { ForwardRef as ReactComponent };